import {useContext} from 'react';
import {Link} from 'react-router-dom';

import bracelet from '../../../assets/Images/bracelet.png';
import gold from '../../../assets/Images/coin.png';
import earrings from '../../../assets/Images/earrings.png';
import imitation from '../../../assets/Images/jewelry.png';
import nosepin from '../../../assets/Images/Nose pin (1).png';
import ring from '../../../assets/Images/rings.png';
import silver from '../../../assets/Images/star.png';
import {FilterContext} from '../../../context/FilterContext/FilterContext';

const NavOptions = () => {
  const {filters, setFilters} = useContext(FilterContext);

  const handleFilterChange = (filterType, filterValue) => {

    if (filterType === 'jewelryType') {

      const map = {
        Gold: 'GOLD',
        Silver: 'SILVER',
        'Imitation Jewellery': 'IMITATION',
      };

      setFilters(prev => ({
        ...prev,
        jewelryType: [map[filterValue]],
        productType: [],
        minPrice: '',
        maxPrice: '',
      }));

    } else {

      const map = {
        Ring: 'RING',
        Earring: 'EARRING',
        Bangle: 'BANGLE',
        Nosepin: 'NOSEPIN',
      };

      setFilters(prev => ({
        ...prev,
        productType: [map[filterValue]],
        jewelryType: [],
        minPrice: '',
        maxPrice: '',
      }));

    }
  };

  const options = [
    {name: 'Gold', path: '/product', image: gold},
    {name: 'Silver', path: '/product', image: silver},
    {name: 'Imitation Jewellery', path: '/product', image: imitation},
    {name: 'Ring', path: '/product', image: ring},
    {name: 'Earring', path: '/product', image: earrings},
    {name: 'Bangle', path: '/product', image: bracelet},
    {name: 'Nosepin', path: '/product', image: nosepin},
  ];

  return (
    <nav className={'hidden lg:flex justify-center items-center transition-all duration-300 w-full h-12 shadow-2xl'}>
      <div className={'hidden lg:flex w-full justify-between items-center xl:gap-2 transition-all duration-300'}>
        {options.map((option, index) => (
          <Link
            key={index}
            to={option.path}
            onClick={() => {
              if (['Gold', 'Silver', 'Imitation Jewellery'].includes(option.name)) {
                handleFilterChange('jewelryType', option.name);
              } else {
                handleFilterChange('productType', option.name);
              }
            }}
            className={'relative pb-1 after:absolute after:left-0 after:bottom-0 after:w-0 after:h-[1.3px] after:bg-white after:transition-all after:duration-300 hover:after:w-full'}>
            <div className={'flex items-center text-white'}>
              <img src={option.image} alt={option.name} className={'mr-1 w-6 h-6'} />
              <span>{option.name}</span>
            </div>
          </Link>
        ))}
      </div>
    </nav>
  );
};

export default NavOptions;
